import React, { useRef, useEffect } from 'react';

import { StyledAvatar } from 'components/avatars';
import { withRouter } from 'react-router-dom';
import { components } from 'react-select';
import AsyncSelect from 'react-select/async';
import styled from 'styled-components';
import { StyledTypography, SearchSelectCSS } from 'styles/common';

import { SEARCH_PLACEHOLDER, SEARCH_WIDGET_TYPES } from 'constants/ProjectConstants';
import { getProfileRoute } from 'constants/helper';

import { searchAutoComplete } from 'services/search';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

function IconOption(props) {
  const { data } = props;

  return (
    <StyledOption {...props}>
      <StyledAvatar display="inline" size="tiny" src={data.image} />

      <TextBodyMedium ml="4px">{data.label}</TextBodyMedium>
    </StyledOption>
  );
}

export function SingleValue(props) {
  const { data } = props;
  return (
    <StyledSingleValue {...props}>
      <StyledAvatar display="inline" size="tiny" src={data.image} />
      <StyledTypography display="inline" leftGutter={1}>
        {data.label}
      </StyledTypography>
    </StyledSingleValue>
  );
}

export function MultipleValue(props) {
  const { data } = props;
  return (
    <StyledMultipleValue {...props}>
      <StyledAvatar display="inline" size="tiny" src={data.image} />
      <StyledTypography display="inline" leftGutter={1}>
        {data.label}
      </StyledTypography>
    </StyledMultipleValue>
  );
}
export function IconOptionSmall(props) {
  const { data } = props;

  return (
    <StyledOption {...props}>
      <StyledAvatar display="inline" size="tiny" src={data.image} />

      <TextBodyMedium ml="4px">{data.label}</TextBodyMedium>
    </StyledOption>
  );
}

export function MultiEmployeePhotoLabel(props) {
  return (
    <components.MultiValueLabel {...props}>
      <StyledAvatar size="tiniest" src={props.data.image} />
    </components.MultiValueLabel>
  );
}

export function MultiEmployeePhotoLabelTinier(props) {
  return (
    <components.MultiValueLabel {...props}>
      <StyledAvatar size="tiny" src={props.data.image} />
    </components.MultiValueLabel>
  );
}

function EmployeeSearch({
  history,
  type,
  displayName,
  searches,
  deletable,
  onChange,
  value,
  className,
  iconOptionType = 'default',
  teamId,
  isMulti = false,
  widgetType,
  components: initialComponents,
  styles: customStyles = {},
  customCSS = {},
  defaultOptions = true,
  defaultValue = null,
}) {
  const handleChange = (option) => {
    const route = getProfileRoute(option.value);
    history.push(route);
    return {};
  };
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  // initially when this component was created, we were passing type
  // and selecting which option component to use, this is not a modular
  // approach, hence provided option to override option component
  const finalComponents = {
    Option: iconOptionType === 'small' ? IconOptionSmall : IconOption,
    ...initialComponents,
  };
  return (
    <SearchInputContainer className={className}>
      <SearchSelect
        placeholder={displayName || SEARCH_PLACEHOLDER}
        // value={searches}
        loadOptions={(value, callback) =>
          searchAutoComplete({
            tagType: 'EMPLOYEE_NAME_AND_EMAIL',
            query: value,
            callback,
            widgetType,
            teamId,
          })
        }
        ref={inputRef}
        defaultOptions={defaultOptions}
        components={finalComponents}
        onChange={onChange || handleChange} // In nominate component I am providing onChange, so I want to be able to use that function here
        classNamePrefix="react-select-custom"
        menuPlacement="auto"
        value={value}
        isMulti={isMulti}
        styles={customStyles}
        customCSS={customCSS}
        defaultValue={defaultValue}
      />
    </SearchInputContainer>
  );
}

const SearchInputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  text-align: left;
  justify-content: center;
`;

const SearchSelect = styled(AsyncSelect)`
  ${SearchSelectCSS};
`;

const StyledOption = styled(components.Option)`
  display: grid !important;
  grid-template-columns: auto 5fr;
  align-items: center;
`;

const StyledSingleValue = styled(components.SingleValue)`
  display: flex;
  align-items: center;
`;

const StyledMultipleValue = styled(components.MultiValue)`
  display: flex;
  align-items: stretch;
`;

EmployeeSearch.defaultProps = {
  tag: {
    tagType: null,
    tagName: null,
  },
  widgetType: SEARCH_WIDGET_TYPES.search,
};

export default withRouter(EmployeeSearch);

// All style keys
/*
    clearIndicator
    container
    control
    dropdownIndicator
    group
    groupHeading
    indicatorsContainer
    indicatorSeparator
    input
    loadingIndicator
    loadingMessage
    menu
    menuList
    menuPortal
    multiValue
    multiValueLabel
    multiValueRemove
    noOptionsMessage
    option
    placeholder
    singleValue
    valueContainer
*/
